module.exports = __webpack_public_path__ + "static/media/Ningbo Lucky.8cd0749e.webp";